import { FC } from 'react'
import cn from 'classnames'
import { emptyImagePlaceholder } from 'constants/image'
import { Link } from 'components/ui'
import { ROUTE_SELLER } from 'routes/sellers'
import { SellerCardProps } from '.'
import s from './seller-card.module.css'

const SellerProfile: FC<SellerCardProps> = ({ seller, className = '' }) => {
  const { name, avatar, description } = seller

  return (
    <Link href={ROUTE_SELLER + seller.slug} className={cn(s.root, className)}>
      <div className={s.avatar}>
        <img src={(avatar && (avatar?.url as string)) || emptyImagePlaceholder} alt={name} />
      </div>
      <div className={s.info}>
        <div className={s.title}>{name}</div>
        <div className={s.description}>{description?.substr(0, 88)}...</div>
      </div>
    </Link>
  )
}

export default SellerProfile
